/* istanbul ignore file */

import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useResponsive } from '@sg/garnish';

import { LocationSearch, PageWrapper } from '@order/components';
import { useFeatureFlag } from '@order/LaunchDarkly';
import { useTrackEventEffect } from '@order/Telemetry';

import type { LocationsScreenProps } from '../../navigation/AppNavigation.props';
import { LocationsScreen as LegacyLocationsScreen } from './LocationsScreen';

// ─────────────────────────────────────────────────────────────────────────────

export const LocationsScreen = memo((props: LocationsScreenProps) => {
  const shouldEnableLocationSearchComponent = useFeatureFlag(
    'XP-3273-short-enable-location-search-component-enabled',
  );

  if (shouldEnableLocationSearchComponent)
    return <LocationScreenWithSearchComponent {...props} />;

  return <LegacyLocationsScreen {...props} />;
});

const LocationScreenWithSearchComponent = memo(
  (props: LocationsScreenProps) => {
    const { params = {} } = props.route ?? {};

    const { currentBreakpoint } = useResponsive();

    // ─── Effects ─────────────────────────────────────────────────────────

    useTrackEventEffect({
      name: 'location.view',
      payload: { orderType: params.locationSelectionType },
    });

    // ─────────────────────────────────────────────────────────────────────

    if (currentBreakpoint.isMobile) {
      return (
        <View style={styles.wrapper}>
          <LocationSearch />
        </View>
      );
    }

    return (
      <PageWrapper contentContainerStyle={styles.wrapper}>
        <LocationSearch />
      </PageWrapper>
    );
  },
);

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    height: '100%',
  },
});
